/**
 * Centralized Fluent UI theme configuration.
 * Imported once (as a side-effect) in App/index.tsx to ensure a single,
 * consistent font stack and design token set across every component.
 *
 * Font stack rationale:
 *  - "Segoe UI" — Microsoft/Windows (matches Power Automate / M365 UI)
 *  - -apple-system / BlinkMacSystemFont — San Francisco on macOS/iOS
 *  - "Roboto" — Android & Linux
 *  - "Helvetica Neue", Arial — universal fallbacks
 */

import { createTheme, loadTheme } from '@fluentui/react';

export const appTheme = createTheme({
  defaultFontStyle: {
    fontFamily:
      '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif',
  },
  fonts: {
    tiny:        { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '10px' },
    xSmall:      { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '10px' },
    small:       { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '12px' },
    smallPlus:   { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '12px' },
    medium:      { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '14px' },
    mediumPlus:  { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '15px' },
    large:       { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '17px' },
    xLarge:      { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '21px' },
    xLargePlus:  { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '24px' },
    xxLarge:     { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '28px' },
    xxLargePlus: { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '32px' },
    superLarge:  { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '42px' },
    mega:        { fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif', fontSize: '72px' },
  },
});

loadTheme(appTheme);
